import type { COMMAND_MENU_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/command-menu/command-menu.fr.ts";
import type { TSearchType } from "~ui/@core/stores/application/application-store.ts";

const placeholdersByType: Record<TSearchType, string> = {
  site: "Search by site id",
  pilot: "Search by pilot hardware id",
  modulator: "Search by modulator hardware id",
};

const types: Record<TSearchType, string> = {
  site: "Sites",
  pilot: "Pilots",
  modulator: "Modulators",
};

export const COMMAND_MENU_ENGLISH_LOCALE = {
  types,
  placeholders: placeholdersByType,
} satisfies typeof COMMAND_MENU_FRENCH_LOCALE;
